"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heights = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
var sizes = {
    xs: {
        fontSize: 10,
        height: 22,
        padding: [0, 11],
    },
    sm: {
        fontSize: 11,
        height: 26,
        padding: [0, 13],
    },
    md: {
        fontSize: 13,
        height: 30,
        padding: [0, 15],
    },
    lg: {
        fontSize: 14,
        height: 36,
        padding: [0, 18],
    },
    xl: {
        fontSize: 16,
        height: 44,
        padding: [0, 22],
    },
};
exports.heights = Object.keys(sizes).reduce(function (acc, size) {
    acc[size] = sizes[size].height;
    return acc;
}, {});
var getWidthStyles = function (fullWidth) { return ({
    display: fullWidth ? 'block' : 'inline-block',
    width: fullWidth ? '100%' : 'auto',
}); };
exports.default = react_jss_1.createUseStyles({
    icon: {
        display: 'flex',
        alignItems: 'center',
    },
    leftIcon: {
        marginRight: 10,
    },
    rightIcon: {
        marginLeft: 10,
    },
    inner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    label: {
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    shared: function (props) { return (__assign(__assign(__assign(__assign(__assign({}, sizes[props.size]), theme_1.getFontStyles(props.theme)), theme_1.getFocusStyles(props.theme)), getWidthStyles(props.fullWidth)), { WebkitTapHighlightColor: 'transparent', userSelect: 'none', boxSizing: 'border-box', textDecoration: 'none', cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none' })); },
    outline: function (_a) {
        var color = _a.color, radius = _a.radius, theme = _a.theme;
        return ({
            backgroundColor: 'transparent',
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            textTransform: 'uppercase',
            fontWeight: 'bold',
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 8 }),
            border: "1px solid " + theme_1.getThemeColor({
                theme: theme,
                color: color,
                shade: theme.colorScheme === 'dark' ? 4 : 8,
            }),
            '&:not(:disabled):active': {
                transform: 'translateY(1px)',
            },
            '&:disabled': {
                borderColor: 'transparent',
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                color: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[5],
                cursor: 'not-allowed',
            },
        });
    },
    light: function (_a) {
        var color = _a.color, size = _a.size, radius = _a.radius, theme = _a.theme;
        return ({
            border: '1px solid transparent',
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            textTransform: 'uppercase',
            fontWeight: 'bold',
            backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 0 }),
            color: theme.colorScheme === 'dark'
                ? theme.colors.dark[9]
                : theme_1.getThemeColor({ theme: theme, color: color, shade: 9 }),
            '& $inner': {
                height: sizes[size].height - 2,
            },
            '&:hover': {
                backgroundColor: theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 5 : 1,
                }),
            },
            '&:not(:disabled):active': {
                transform: 'translateY(1px)',
            },
            '&:disabled': {
                borderColor: 'transparent',
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                color: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[5],
                textShadow: 'none',
                cursor: 'not-allowed',
            },
        });
    },
    filled: function (_a) {
        var color = _a.color, size = _a.size, radius = _a.radius, theme = _a.theme;
        return ({
            border: '1px solid transparent',
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            textTransform: 'uppercase',
            fontWeight: 'bold',
            backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
            textShadow: "1px 1px 0 " + theme_1.getThemeColor({ theme: theme, color: color, shade: 8 }),
            color: theme.white,
            '& $inner': {
                height: sizes[size].height - 2,
            },
            '&:hover': {
                backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 7 }),
            },
            '&:not(:disabled):active': {
                transform: 'translateY(1px)',
            },
            '&:disabled': {
                borderColor: 'transparent',
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                color: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[5],
                textShadow: 'none',
                cursor: 'not-allowed',
            },
        });
    },
    link: function (_a) {
        var color = _a.color, radius = _a.radius, theme = _a.theme;
        return ({
            padding: 0,
            borderRadius: theme_1.getSizeValue({ size: radius, sizes: theme.radius }),
            backgroundColor: 'transparent',
            border: 0,
            display: 'inline-block',
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline',
            },
            '&:disabled': {
                color: theme.colors.gray[5],
                cursor: 'not-allowed',
                '&:hover': {
                    textDecoration: 'none',
                },
            },
        });
    },
}, { link: true });
